<template>
  <div>
    <div class="heading">Admins</div>

    <admin-filter></admin-filter>

    <admin-list v-show="tab === 0"></admin-list>
    <admin-add></admin-add>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="admin.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminFilter from './Filter'
import adminList from './AdminList'
import adminAdd from './AdminAdd'
import ApiAdmin from '@/modules/api/admin'

export default {
  name: 'brands',
  components: { adminFilter, adminList, adminAdd },
  data () {
    return {
      tab: 0,
      searchInput: '',
      status: ''
    }
  },
  computed: {
    admin () { return this.$store.state.admin.list },
    loading () { return this.$store.state.admin.loading },
    perPage: {
      get: function () { return this.$store.state.admin.perPage },
      set: function (value) {
        this.$store.commit('admin/setPerPage', parseInt(value))
        this.$store.commit('admin/setCurrentPage', 1)
        this.getAdmins()
      }
    },
    pageData () {
      let tableData = this.$store.state.admin
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.admin.currentPage },
      set: function (value) {
        this.$store.commit('admin/setCurrentPage', parseInt(value))
        this.getAdmins()
      }
    },
    isLastPage () {
      let admin = this.$store.state.admin
      return (admin.currentPage * admin.perPage) >= admin.maxList
    },
    totalPage () {
      let admin = this.$store.state.admin
      return Math.ceil(admin.maxList / admin.perPage)
    }
  },
  methods: {
    showForm () { this.$store.commit('admin/setShowForm', true) },
    getAdmins () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('admin/setLoading', true)
      ApiAdmin.getAdmins(self, {}, function (res) {
        self.$store.commit('admin/setLoading', false)
      })
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('admin/setCurrentPage', this.$store.state.admin.currentPage - 1)
      this.getAdmins()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('admin/setCurrentPage', this.$store.state.admin.currentPage + 1)
      this.getAdmins()
    }
  },
  watch: {},
  mounted () {}
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  margin-bottom: 10px;
  border-radius: 2px;

  .row{ max-width: 100%; }
}

.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.search-box{
  display: inline-block;
  padding: 20px 0 20px 15px;
  position: relative;
  width: 100%;

  .error-msg{
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 15px);
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    margin-left: 15px;
    background: #ff6115;
    color: #fff;
    transform-origin: bottom center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.status{
  display: inline-block;
  padding: 20px 0 20px 15px;
  width: 100%;

  &.last{ padding-right: 10px; }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{
    max-width: 100px;
    height: 30px;
    padding: 5px;
  }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 10px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 10px 0;
  }
  .pagination{
    text-align: right;
    padding: 10px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      width: 45%;

      select {
        width: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/index.vue